import { MultipleChoiceStandardSettings } from 'apps/studio/components/settings/fields/MultipleChoice/standard'
import { FieldSettingsPanel } from 'apps/studio/components/settings/fields/Base/standard'
import { DesignSettingsPanel } from 'apps/studio/components/settings/fields/Base/design'
import { ChoicesPanel } from 'apps/studio/components/settings/fields/Base/choices'
import { AdvancedPanel } from 'apps/studio/components/settings/fields/Base/advanced'

export const MultipleChoiceSettings = [
  FieldSettingsPanel(MultipleChoiceStandardSettings),
  DesignSettingsPanel,
  ChoicesPanel(),
  // ConditionsPanel,
  AdvancedPanel,
]
